import React, { useState, useEffect } from 'react';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import SalesController, { SalesListType } from '../../controller/SalesController';
import DetectorController from '../../controller/DetectorController';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  storeDetailData: SalesListType | null;
  successOrder: any;
};

const ReadyAdminForceModal = ({ isVisible, setVisible, storeDetailData, successOrder }: Props) => {
  const [deliveryBasicTime, setDeliveryBasicTime] = useState<string>('');
  const [deliveryTime, setDeliveryTime] = useState<string>('');
  const [adminName, setAdminName] = useState<string>('');
  const onCloseModal = () => {
    setVisible(false);
  };
  const handleDeliveryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDeliveryTime(e.target.value);
  };
  const handleAdminChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAdminName(e.target.value);
  };

  const getStoreList = async () => {
    try {
      const response = await DetectorController.getStoreList(storeDetailData?.store_id);
      if (response && response.data) {
        setDeliveryBasicTime(response.data.data.delivery_manage.delivery_estimated_time);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  useEffect(() => {
    if (isVisible && storeDetailData) {
      getStoreList();
    }
  }, [isVisible]);
  return (
    <Style>
      {isVisible && (
        <div className="modalWrap">
          <div className="modalBackground" onClick={onCloseModal}></div>
          <div className="modal">
            <div className="modalContent">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                alt="닫기"
                width={28}
                className="modalCloseButton"
                onClick={onCloseModal}
              />
              <div className="content">
                <h2>매장에서 설정한 배달 도착시간</h2>
                <h1>{deliveryBasicTime}분</h1>
              </div>
              <div className="content deliveryTimeWrap">
                <input
                  type="number"
                  value={deliveryTime}
                  onChange={handleDeliveryChange}
                  placeholder="배달 도착 시간을 입력해주세요"
                />
                <p>분</p>
              </div>
              <input
                type="text"
                value={adminName}
                onChange={handleAdminChange}
                placeholder="등록하는 관리자 명을 입력해주세요."
              />
              <button onClick={() => successOrder(deliveryTime, adminName)}>확인</button>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default ReadyAdminForceModal;

const Style = styled.div`
  /* 공통 */
  .modalContent {
    position: relative;
    width: 30%;
    padding: 50px 4%;
    overflow-y: auto;
    z-index: 9999;
    text-align: left;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .modalCloseButton {
    position: absolute;
    top: 3%;
    right: 2%;
    cursor: pointer;
  }
  h2 {
    padding: 0;
    font-size: 18px !important;
    font-weight: 500;
    color: #333;
  }
  h1 {
    margin-bottom: 0px !important;
    font-weight: 600;
    background: yellow;
  }
  h3 {
    font-size: 16px;
    font-weight: 400;
    color: #555;
  }
  input {
    width: 95%;
    padding: 10px;
    border: none;
    border-bottom: 1px solid #000;
    outline: none;
  }

  .content {
    margin-bottom: 40px;
    display: flex;
    gap: 3%;
    align-items: center;
  }
  .deliveryTimeWrap {
    position: relative;

    p {
      position: absolute;
      bottom: 5%;
      right: 0;
      margin: 0;
    }
  }

  button {
    width: 100%;
    margin-top: 50px;
    padding: 10px;
    background: #000;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 10px;
  }

  @media (max-width: 1200px) {
    .modalContent {
      width: 80%;
    }
  }
`;
